/**
 * Placeholder subject sent when the user leaves Meeting title blank and
 * generate_smart_subject is true. Matches Meeting Details interim title UI.
 */
export const MEETING_INTERIM_SMART_TITLE = 'Generating title...';
